import { TableInstance } from "react-table";

// UUID type definition (compatible with crypto.randomUUID() output)
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

export type Page = { href: string, name: string }

// Drill-down list "return highlight" persisted state (checklist page), scoped by path.
export type ChecklistLastClicked = { path: string; ctUuid: string };

export type SequenceNumber = string;

export type SequenceList = SequenceNumber[];

export type AssignmentApiData = {
    "id": number,
    "fullName": string,
    "email": string,
    "projectNumber": number,
    "disciplineId": number,
    "sequence": string,
    "checklistType": string,
    "caCc": string,
    "location": Array<number>,
    "adhocAbility": string,
    "assignmentUuid": string,
    "kionEmail": string,
    "loginId": string,
    "idTagInitial"?: string,
    "accessLevelId"?: number,
    "canModifyRoles"?: boolean,
}

export type UserAssignment = {
    "id": number,
    "fullName": string,
    "email": string,
    "role": string,
    "projectNumber": number,
    "disciplineId": number,
    "sequence": string,
    "checklistType": string,
    "caCc": string,
    "location": Array<number>,
    "adhocAbility": string,
    // "uuid": string,
    "assignmentUuid": string,
    "kionEmail": string,
    "loginId": string,
    project?: string,
    discipline?: string,
    jwt?: string,
    idTagInitial?: string,
    accessLevelName?: string,
    canModifyRoles?: boolean,
}
export type AssignmentObject = {
    "id": number,
    "fullName": string,
    "email": string,
    "projectNumber": number,
    "disciplineId": number,
    "sequence": string,
    "checklistType": string,
    "caCc": string,
    "location": string,
    "adhocAbility": string,
    "kionEmail": string,
    "loginId": string,
    "uuid": string,
}

export type Discipline = {
    "disciplineId": number,
    "disciplineName": string,
    "disciplineCode": string,
    "drillDownProcess": string,
}

export type Project = {
    "projectNumber": number,
    "projectName": string,
    "projectLocation": string,
    "country": string,
    "isArchived": boolean
}

export type RelatedChecklistDetails = {
    // "status": number,
    // "projectNumber": number,
    // "disciplineId": number,
    // "sequenceNumber": number,
    // "unitNumber": number,
    // "modelNumber": "string",
    // "modelFull": "string",
    // "inspectionTask": "string",
    // "checklistUuid": "string",

    "ctUuid": string,
    "status": number,
    "projectNumber": number,
    "disciplineId": number,
    "drilldownTypeId": number,
    "dd01": string,
    "dd02": string,
    "dd03": string,
    "modelNumber": string,
    "modelDescription": string,
    "taskHeader": string,
    "taskDescription": string,
}

export function getProjectText(project: Project): string {
    return `${project.projectNumber} - ${project.projectName}`;
}
export type UnitChecklistItem = {
    address?: string,
    assignedOn?: Date,
    caCc?: any,
    checklistType?: string,
    checklistUuid?: UUID,
    columnOrder: number,
    dateCreated?: Date,
    dateModified?: Date,
    descriptionDetails?: string,
    deviceInspections?: any,
    projectNumber: number,
    disciplineId: number,
    generalInspections?: any,
    id?: number,
    inspectionId?: number,
    inspectionTask: string,
    inspectionTestType?: string,
    inspectionVersion?: Date,
    isArchived?: false,
    location?: any,
    modelFull: string,
    modelNumber: string,
    plcAddress?: any,
    qrCode?: any
    sequenceName?: string
    sequenceNumber: string
    status?: number,
    unitNumber: string,
    twClassNames?: string,
    passedIcon_twClassNames?: string,
    failedIcon_twClassNames?: string,
    NAIcon_twClassNames?: string,
    notSync?: boolean,
    mpcStatus?: number,
    creation?: boolean
}

export type CACC = {
    "status": number,
    "projectNumber": number,
    "disciplineId": number,
    "checklistType": string,
    "caCc": string,
    "location": string,
    "deviceInspections": string,
    "descriptionDetails": string,
    "plcAddress": string,
    "address": string,
    "inspectionTestType": string,
    "inspectionTask": string,
    "generalInspections": string, // check again
    "qrCode": string, // check again
    // "checklistControlUuid": string,
    "columnOrder": string, // check again
    "dateCreated": string,
    "dateModified": string,
    "inspectionVersion": string, // check again
    "isArchived": false
}

export type PunchListItem = {
    ermType?: string;
}

export type Comment = {
    "commentUuid": string,
    "commentType": number,
    "projectNumber": string,
    "commentText": string,
    "addedBy": string,
    "addedEmail": string,
    "addedOn": string,
    // "unitChecklistUuid": string,
    "punchlistUuid": string,
    "ctUuid": string,
    "disciplineId": string,
    // unitChecklistId?: string,
    // punchlistId?: string,
    // "id"?: number,
    notSync?: boolean
    creation?: boolean
    previousCommentText?: string
}

export type ChangeLog = {
    // "id": number,
    "changelogTypeId": number,
    "projectNumber": string,
    "changedByDisciplineId": string,
    // "punchListId": string;
    "punchlistUuid": string;
    "ctUuid": string;
    "description": string,
    "changedBy": string,
    "changedEmail": string,
    "changedOn": string,
    "changelogUuid": string,
}
export type ChangeLogType = {
    "id": number,
    "typeName": string,
    "description": string
}
export type Status = {
    "statusId": number,
    "statusName": string,
    "statusDescription": string
}
export type Issue = {
    "issueId": number,
    "issueDescription": string,
    "mechanicalPc": string,
    "electricalPc": string,
    "mechanicalInstall": string,
    "electricalInstall": string,
    "controlEngineering": string,
    "mechanicalEngineering": string,
    "qaSafety": string,
    "siteManager": string,
}

export type RootCause = {
    listOrder: number,
    rootCauseDescription: string,
    rootCauseId: number
}
export type OnHoldCause = {
    ohrId: number,
    ohrDescription: string,
    listOrder: number
}

export type TTechnology = {
    technologyId: number,
    technologyDescription: string
}

export type TRegion = {
    regionId: number,
    regionDescription: string
}

export type TInspectionTask = {
    inspectionId: number,
    taskDescription: string,
    inspectionTaskId: number,
    listOrder: number,
    taskHeader: string;
    inspectionTaskLinks?: TInspectionTaskLink[]
}
export type TInspections = {
    inspectionId: number,
    disciplineId: number,
    modelNumber: string,
    inspectionDescription: string,
    inspectionVersion: string
    // checklistLinks?: TCheckListLink[]
}

export type TBusinessUnits = {
    businessUnitId: number,
    businessUnitDescription: string,
    regionId: number
}

export type TAccessLevel = {
    accessLevelId: number,
    accessLevelName: string,
    accessLevelDescription: string,
    adGroupLink: string
}

export type TLinkDisciplineIssue = {
    disciplineIssueLinkId: number,
    disciplineId: number,
    issueId: number,
    listOrder: number
}

export type TLinkDisciplineTechCategory = {
    disciplineTechnologyCategoryLinkId: number,
    disciplineId: number,
    technologyId: number,
    categoryId: number,
    listOrder: number
}


export type Category = {
    "categoryId": number,
    "categoryDescription": string,
    "mechanicalPc": string,
    "electricalPc": string,
    "mechanicalInstall": string,
    "electricalInstall": string,
    "controlEngineering": string,
    "mechanicalEngineering": string,
    "qaSafety": string,
    "site_manager": string,
}


export type ObjectToSync = {
    url: string,
    payload: any
    method: string,
    type: string,
    preRequests?: Array<ObjectToSync>
    jwt?: string
    syncMeta?: {
        queueId?: string,
        itemId?: string,
        itemLabel?: string,
        resourceType?: string,
        localBaseTimestamp?: string | null,
        localUpdatedAt?: string,
        ignoreConflictCheck?: boolean,
    }
}

export type DrawingType = {
    "id": number,
    "drawingId": string,
    "drawingName": string,
    "projectNumber": number
}
export type FileDrawingType = {
    drawingDisplayName: string,
    drawingFilename: string,
    drawingUuid: string,
    projectNumber: number,
    loadForProject?: boolean,
}

export type MPCStatus = {
    meChecklistUuid: string
    mpcChecklistUuid: string
    mpcStatus: number
    projectNumber: number
    sequenceNumber: number
    unitNumber: number
}

export type TInspectionTaskLink = { linkUrl: string, linkText: string, linkCategory: string, itLinkId: number, inspectionTaskId: number }

export interface ExtendedProjects {
    archivedPunchListCount: number
    archivedTaskCount: number
    country: string
    dateCreated: string
    isArchived: boolean
    openTaskCount: number
    pendingQueueJobCount: number
    projectLocation: string
    projectName: string
    projectNumber: number
    projectSequenceCount: number
    projectTypeDescription: string
    projectTypeId: number
    regionDescription: string
    regionId: number
    specialHandlingRequired: boolean
    targetImportUnitCount: number
    totalImportUnitCount: number
    totalPunchListCount: number
    totalTaskCount: number
    sapUnitCount: number
    sapTaskCount: number
    radComponentCount: number
    radTaskCount: number
}

export type TAddProjectAPIResponse = {
    itemId: number | null
    message: string,
    success: boolean
}

export type TProjectFormData = {
    projectName: string;
    projectNumber: number;
    projectLocation: string;
    sapVersionId: number;
    regionId: number;
    businessUnitId?: number;
    country: string;
    isArchived: boolean;
}

export enum JobsMapping {
    PullProjectUnits = 1,
    GenerateMechanicalChecklists = 2,
    LoadRADComponents = 3,
    GenerateElectricalChecklists = 4,
}

export enum JobsFeedbackMessages {
    projectUnitsPullConfirmation = "Pull Project Units from SAP",
    projectUnitedPullSuccess = "Added Queue Job to Load Project Units from SAP",
    projectUnitedPullError = "Could not Add Queue Job to Pull Project Units, This project requires special handling.",
    loadRADComponentsConfirmation = "Load RAD Components",
    loadRADComponentsSuccess = "Added Queue Job to Load RAD Components",
    loadRADComponentsError = "Could not Add Queue Job to Load RAD Components, This project requires special handling.",
    generateMechanicalChecklistsConfirmation = "Generate Mechanical Checklist Tasks",
    generateMechanicalChecklistsSuccess = "Added Queue Job to Generate Mechanical Checklist Tasks",
    generateMechanicalChecklistsError = "Could not Add Queue Job to Generate Mechanical Checklist Tasks, This project requires special handling.",
    generateElectricalChecklistsConfirmation = "Generate Electrical Checklist Tasks",
    generateElectricalChecklistsSuccess = "Added Queue Job to Generate Electrical Checklist Tasks",
    generateElectricalChecklistsError = "Could not Add Queue Job to Generate Electrical Checklist Tasks, This project requires special handling.",
}

export type TPaginationProps<T> = {
    currentPage: number;
    setCurrentPage: (page: number) => void;
    totalPages: number;
    currentRows: T[];
    handleNextPage: () => void;
    handlePreviousPage: () => void;
};

export type TTableProps<T> = TableInstance<T>;
